import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

interface TooltipItem {
    label?: string;
    text?: string;
    youtube_video?: string | null;
}

type TooltipDialogData =
    | { items?: TooltipItem[] }
    | { text?: string; youtube_video?: string | null };

@Component({
    selector: 'app-question-tooltip',
    templateUrl: './question-tooltip.component.html',
    styleUrls: ['./question-tooltip.component.scss'],
})
export class QuestionTooltipComponent implements OnInit {
    activeIndex = 0;
    loading = false;
    private currentSafeUrl: SafeResourceUrl | null = null;
    constructor(
        public dialogRef: MatDialogRef<QuestionTooltipComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: TooltipDialogData | null,
        private sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
        if (this.items && this.items.length > 0) {
            this.loading = !!this.items[this.activeIndex]?.youtube_video;
        } else if (this.singleVideo) {
            this.loading = true;
        }

        this.updateSafeUrl();
    }

    get safeVideoUrl(): SafeResourceUrl | null {
        return this.currentSafeUrl;
    }

    private getCurrentVideo(): string | null {
        if (!this.data) return null;
        if (this.singleVideo) return this.singleVideo;
        if (this.items && this.items.length > 0) return this.items[this.activeIndex]?.youtube_video || null;
        return null;
    }

    private buildEmbedUrl(raw: string): string {
        let url = raw || '';
        if (url.includes('watch?v=')) url = url.replace('watch?v=', 'embed/');
        if (url.includes('youtu.be/')) url = url.replace('youtu.be/', 'www.youtube.com/embed/');
        if (!url.startsWith('http')) url = 'https://' + url;
        return url;
    }

    private updateSafeUrl() {
        const video = this.getCurrentVideo();
        if (!video) {
            this.currentSafeUrl = null;
            return;
        }
        const embed = this.buildEmbedUrl(video);
        this.currentSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embed);
    }

    private isItemsData(d: TooltipDialogData | null): d is { items: TooltipItem[] } {
        return !!d && (d as any).items !== undefined && Array.isArray((d as any).items);
    }

    get items(): TooltipItem[] | null {
        return this.isItemsData(this.data) ? this.data.items : null;
    }

    get singleText(): string | null {
        return this.data && 'text' in this.data ? (this.data as { text?: string }).text ?? null : null;
    }

    get singleVideo(): string | null {
        return this.data && 'youtube_video' in this.data
            ? (this.data as { youtube_video?: string | null }).youtube_video ?? null
            : null;
    }

    selectIndex(i: number) {
        this.activeIndex = i;
        const v = this.getCurrentVideo();
        this.loading = !!v;
        this.updateSafeUrl();
    }

    onVideoLoaded() {
        this.loading = false;
    }

    close() {
        this.dialogRef.close();
    }
}
